"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    handleDate: ()=>handleDate,
    useStashBoardFilter: ()=>useStashBoardFilter
});
const _dayjs = /*#__PURE__*/ _interopRequireDefault(require("dayjs"));
const _react = require("react");
const _lodash = require("lodash");
const _ = require("..");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const handleDate = (expirationDateInDays, date)=>{
    if (!date) {
        return false;
    }
    if (!expirationDateInDays && expirationDateInDays !== 0) {
        return date;
    }
    const now = (0, _dayjs.default)();
    const msgSentAt = (0, _dayjs.default)(date * 1000);
    const msgDateDiff = now.diff(msgSentAt, 'day');
    if (msgDateDiff >= expirationDateInDays) {
        return false;
    }
    return date;
};
const useStashBoardFilter = (setItems)=>{
    const { stashboards , member , stashboardKeys  } = (0, _.useSpringBigStore)();
    const { expirationDateInDays  } = (0, _.useAppSettings)();
    (0, _react.useEffect)(()=>{
        if (!stashboards || !stashboards?.length) {
            return;
        }
        const filtered = stashboards.filter((item)=>item.merchant_id * 1 === member?.merchant_id);
        const alreadyFetched = filtered?.map((k)=>k._key);
        const oldKeys = stashboardKeys?.filter((k)=>alreadyFetched?.includes(k.stashboard_key));
        const validStashboardKeys = oldKeys?.filter((key)=>!!handleDate(expirationDateInDays, key.epoch));
        const _stashboards = stashboards?.filter((s)=>validStashboardKeys?.map((k)=>k.stashboard_key).includes(s._key));
        setItems((0, _lodash.orderBy)(_stashboards, [
            'sent_at'
        ], [
            'desc'
        ]));
    }, [
        stashboards,
        member?.merchant_id,
        setItems
    ]);
};
